export const C = {
  orange:      'rgb(255, 140, 30)',
  orangeDeep:  'rgb(230, 100, 10)',
  orangeBurnt: 'rgb(180, 70,  0)',
  orangeTint:  'rgb(255, 215, 160)',
  orangeCream: 'rgb(255, 245, 232)',
  black:       'rgb(18,  18,  20)',
  charcoal:    'rgb(38,  38,  42)',
  graphite:    'rgb(80,  80,  88)',
  silver:      'rgb(220, 220, 224)',
  offwhite:    'rgb(248, 248, 250)',
  white:       '#ffffff',
  green:       'rgb(34,  160, 90)',
  blue:        'rgb(30, 120, 210)',
  yellow:      'rgb(180, 130, 20)',
  olive:       'rgb(100, 150, 20)',
  red:         'rgb(200, 60, 60)',
  purple:      'rgb(180, 60, 180)',
  /* ── light surface tokens ── */
  pageBg:      "rgb(246, 247, 249)",
  cardBg:      "rgb(255, 255, 255)",
  cardImgBg:   "rgb(238, 241, 245)",
  borderLight: "rgb(225, 228, 233)",
  textBody:    "rgb(30,  32,  36)",
  textMuted:   "rgb(95,  100, 110)",
};

export const FD = "'Playfair Display', serif";
export const FB = "'DM Sans', sans-serif";

export default {
  C,
  FD,
  FB,
};
